const toastTheme = {
  wrapper:
    "pointer-events-auto mx-auto w-96 max-w-full rounded-lg bg-clip-padding text-sm shadow-lg shadow-black/5",
  wrapperTransition:
    "transition duration-300 ease-in-out motion-reduce:transition-none",
  wrapperVisible: "opacity-100",
  wrapperHidden: "opacity-0",
  nonStatic: "fixed top-4 right-4",
};

export default toastTheme;
